/**
 * 管理员
 */
const App = () => import('@/module/index/layout/App.vue')
const adminrole = () => import('@/module/index/pages/admin/role.vue')
const adminroleEdit = () => import('@/module/index/pages/admin/roleEdit.vue')
const adminorganization = () => import('@/module/index/pages/admin/organization.vue')
const adminorganizationEdit = () => import('@/module/index/pages/admin/organizationEdit.vue')
const adminaccount = () => import('@/module/index/pages/admin/account.vue')
const adminaccountEdit = () => import('@/module/index/pages/admin/accountEdit.vue')
const abilityTemple = () => import('@/module/index/pages/admin/abilityTemple.vue')
const abilityTempleEdit = () => import('@/module/index/pages/admin/abilityTempleEdit.vue')

export default {
  path: '/admin',
  component: App,
  redirect: '/admin/role',
  meta: {
    title: '',
    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    isback: true
  },
  children: [{
    path: '/admin/role',
    component: adminrole
  },
  {
    path: '/admin/role/edit/add',
    component: adminroleEdit
  },
  {
    path: '/admin/role/edit/detail/:id',
    component: adminroleEdit
  },
  {
    path: '/admin/role/edit/:id',
    component: adminroleEdit
  },
  {
    path: '/admin/organization',
    component: adminorganization
  },
  {
    path: '/admin/organization/edit/add',
    component: adminorganizationEdit
  },
  {
    path: '/admin/organization/edit/:id',
    component: adminorganizationEdit
  },
  {
    path: '/admin/organization/edit/detail/:id',
    component: adminorganizationEdit
  },
  {
    path: '/admin/account',
    component: adminaccount
  },
  {
    path: '/admin/account/edit/add',
    component: adminaccountEdit
  },
  {
    path: '/admin/account/edit/:id',
    component: adminaccountEdit
  },
  {
    path: '/admin/account/edit/detail/:id',
    component: adminaccountEdit
  },
  {
    path: '/admin/abilityTemple',
    component: abilityTemple
  },
  {
    path: '/admin/abilityTemple/edit/add',
    component: abilityTempleEdit
  },
  {
    path: '/admin/abilityTemple/edit/:id',
    component: abilityTempleEdit
  },
  {
    path: '/admin/abilityTemple/edit/detail/:id',
    component: abilityTempleEdit
  }
  ]
}



// WEBPACK FOOTER //
// ./src/publicResource/router/admin.js